import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './views/home/home.component';
import { SearchComponent } from './views/search/search.component';
import { DatasetComponent } from './views/search/dataset/dataset.component';
import { ExperimentComponent } from './views/search/dataset/experiment/experiment.component';
import { ManagementAnalyticsComponent } from './views/management-analytics/management-analytics.component';
import { SamplesComponent } from './views/search/samples/samples.component';

const routes: Routes = [
  { path: 'data-upload', loadChildren: () => import('./views/data-upload/data-upload.module').then(m => m.DataUploadModule), canActivate: [AuthGuard] },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuard] },
  { path: 'dataset/:id', component: DatasetComponent, canActivate: [AuthGuard] },
  { path: 'experiment/:id', component: ExperimentComponent, canActivate: [AuthGuard] },
  { path: 'samples/:id', component: SamplesComponent, canActivate: [AuthGuard] },
  { path: 'early-warnings', component: ManagementAnalyticsComponent, canActivate: [AuthGuard] },
  { path: '', component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
